module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "CHAPTER1",
    attrs: {
      "id": "uKS4kNhcIOYlLRFjw6rQFs5",
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "id": "uoThBMVTm5JCLt3lRrAWJCF"
    }
  }), _vm._v("NOTE")]), _vm._v(" "), _c('p', {
    staticClass: "Perfect-Center",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "italics"
  }, [_vm._v("Any grammatical errors found in quoted text and testimony are attributable to the original authors and should not be considered errors by the author or publisher.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d8d902d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/note.vue
// module id = 69
// module chunks = 0